import i18n from "../index";

export const loadNamespace = async (namespace, path) => {
  const languages = ["en", "hi"];

  for (const lng of languages) {
    if (i18n.hasResourceBundle(lng, namespace)) continue;

    const data = await import(`../locales/${lng}/${path}`);
    i18n.addResourceBundle(lng, namespace, data.default, true, true);
  }
};